module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/deodorant@3x_bd2171.png";